import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
//import { MatDialog } from '@angular/material/dialog';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-analytics-segment-dialog',
  templateUrl: './analytics-segment-dialog.component.html',
  styleUrls: ['./analytics-segment-dialog.component.scss']
})
export class AnalyticsSegmentDialogComponent implements OnInit {

  form: FormGroup;
  segments: Array<any> = [];
  segmentsScheduled: Array<any> = [];
  @ViewChild('segmentList', { static: false }) segmentList: MatSelectionList
  filters: any;
  extrasFilters: any;
  submiting: boolean = true;

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data,
    //private change: ChangeDetectorRef,
    private dialogRef: MatDialogRef<AnalyticsSegmentDialogComponent>
  ) {

    this.filters = data.filters;
    this.extrasFilters = data.extrasFilters;
    this.form = fb.group({
      name: [null, Validators.required]
    });

  }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe(
      (result: any) => {

        const { scope, trigger } = result;
        if (scope.indexOf('segment') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject);

    this.form
      .get('name')
      .valueChanges
      .pipe(
        debounceTime(500)
      )
      .subscribe(
        name => {
          this.getSegments({ name });
        },
        err => this.errorReport.showMessage(err)
      );

    this.getSegments();

  }

  getSegmentScheduled() {

    const formatedFilters = [];
    for (const filter of this.filters) {
      const params = {
        filterName: filter.name,
        filterValue: filter.value.toLowerCase() === 'não informado' ? '' : filter.value
      };
      formatedFilters.push(params);
    }

    this.http.list('segment:import', { filters: JSON.stringify(formatedFilters) })
      .subscribe(
        (result: any) => {

          this.segmentsScheduled = result.data;

          for (let segment of this.segments)
            segment.hasImportSchedule = this.hasScheduleImport(segment);

        },
        err => this.errorReport.showMessage(err)
      );


  }

  getSegments(params = {}) {

    this.http.list('segment', params)
      .subscribe(
        (result: any) => {
          this.segments = result.data;
          this.getSegmentScheduled();
        },
        err => this.errorReport.showMessage(err)
      )

  }

  addSegment() {

    const data = this.form.getRawValue();
    const isValid = !this.form.invalid;

    if (isValid) {

      this.http.save('segment', data)
        .subscribe(
          result => {
            this.snackbar.open('Segmento adicionado com sucesso!', 'OK', { duration: 2000 });
            //this.form.reset();
            setTimeout(() => this.getSegments({ name: data.name }), 1000);
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  hasScheduleImport(segment) {
    return this.segmentsScheduled.findIndex(_import => _import.leadlist_id == segment.id) > -1;

  }

  disabledButton() {

    return this.segments.length ? this.segmentList.selectedOptions.selected.length === 0 : true

  }

  importSegment() {

    const values = this.segmentList.selectedOptions.selected.values();
    const segments = [];

    for (const item of values) {
      const { value } = item;
      segments.push(value.id);
    }

    const formatedFilters = [];
    for (const filter of this.filters) {
      const params = {
        filterName: filter.name,
        filterValue: filter.value.toLowerCase() === 'não informado' ? '' : filter.value
      };
      formatedFilters.push(params);
    }

    const data = {
      segments,
      filters: formatedFilters,
      extrasFilters: this.extrasFilters
    };
    this.http.save('segment:import', data)
      .subscribe(
        (result: any) => {

          if (result.type === 'OK') {
            alert('Importação desses candidatos foi agendada para ser feito, você receberá um aviso quando a importação terminar');
            this.dialogRef.close(true);
          }

        }
      )

  }

}
